import { Link } from "react-router-dom";
import { Star, MapPin } from "lucide-react";
import { fileUrl } from "@/lib/api";
import { useLang } from "@/contexts/LangContext";

export default function StoreCard({ store }) {
    const { t } = useLang();
    return (
        <Link
            to={`/store/${store.slug}`}
            className="group block rounded-2xl overflow-hidden border border-border bg-white hover:-translate-y-1 hover:shadow-lg transition-transform transition-shadow duration-300"
            data-testid={`store-card-${store.slug}`}
        >
            <div className="h-32 bg-gradient-to-br from-ochre/30 to-terracotta/20 relative overflow-hidden">
                {store.cover_url && (
                    <img src={fileUrl(store.cover_url)} alt={store.name} className="w-full h-full object-cover" />
                )}
            </div>
            <div className="px-5 pb-5 -mt-8 relative">
                <div className="w-16 h-16 rounded-2xl bg-white shadow-md border border-border grid place-items-center overflow-hidden">
                    {store.logo_url ? (
                        <img src={fileUrl(store.logo_url)} alt={store.name} className="w-full h-full object-cover" />
                    ) : (
                        <span className="text-2xl font-black text-terracotta">{store.name?.[0] || "س"}</span>
                    )}
                </div>
                <h3 className="mt-3 font-bold text-espresso text-lg">{store.name}</h3>
                {store.description && (
                    <p className="text-sm text-muted-foreground mt-1 line-clamp-2">{store.description}</p>
                )}
                <div className="flex items-center gap-3 mt-3 text-xs text-muted-foreground">
                    {store.rating > 0 && (
                        <span className="flex items-center gap-1">
                            <Star className="w-3.5 h-3.5 fill-ochre text-ochre" />
                            {store.rating.toFixed(1)}
                        </span>
                    )}
                    <span className="flex items-center gap-1">
                        <MapPin className="w-3.5 h-3.5" />
                        {store.city}
                    </span>
                </div>
            </div>
        </Link>
    );
}
